
import BullBullConst from "../../utils/bullbull_const";
import TablePokerBase from "../../../../table/module/table_base/table_poker_base";

const {ccclass, property} = cc._decorator;

@ccclass
export default class BullCardValueCom extends TablePokerBase {

    @property(cc.SpriteAtlas)
    pokerAtlas : cc.SpriteAtlas = null;
    
    @property(cc.Sprite)
    pointSprite : cc.Sprite = null;

    @property(cc.Sprite)
    colorSprite : cc.Sprite = null;

    @property(cc.Sprite)
    bigColorSprite : cc.Sprite = null;

    @property(cc.Node)
    backNode : cc.Node = null;
    
    
    private _cardValue : number = 0;
    get cardValue(){

        return this._cardValue;
    }

    onEnable(){

        this.node.opacity = 255;

        this.spriteBack = this.backNode.getComponent(cc.Sprite);
    }


    updateCard(playerId : number, number: string ,colour: string){

        if (number == "0") {
            //牌背
            this.showBack(playerId);
            return;
        }

        number = BullBullConst.POKER_NUMBER_MAP[number].toString();

        this._cardValue = Number(number);

        this.pointSprite.node.active = true;
        this.colorSprite.node.active = true;
        this.bigColorSprite.node.active = true;
        this.backNode.active = false;

        let cardNum = Number(number);
        let bigColorValue : string = "";
        //先看花色
        if (colour == "S") {
            //黑桃
            this.pointSprite.spriteFrame = this.getSpriteFrame("point_black_" + number);
            this.colorSprite.spriteFrame = this.getSpriteFrame("color_black_heart_small");

            if (cardNum > 10) {
                bigColorValue = "color_black_heart_" + cardNum.toString();
            }else{
                bigColorValue = "color_black_heart_big";
            }
            this.bigColorSprite.spriteFrame = this.getSpriteFrame(bigColorValue)
            
        }else if(colour == "H"){            
            //红桃
            this.pointSprite.spriteFrame = this.getSpriteFrame("point_red_" + number);
            this.colorSprite.spriteFrame = this.getSpriteFrame("color_red_heart_small");

            if (cardNum > 10) {
                bigColorValue = "color_red_heart_" + cardNum.toString();
            }else{
                bigColorValue = "color_red_heart_big";
            }
            this.bigColorSprite.spriteFrame = this.getSpriteFrame(bigColorValue)

        }else if(colour == "C"){

            //梅花
            this.pointSprite.spriteFrame = this.getSpriteFrame("point_black_" + number);
            this.colorSprite.spriteFrame = this.getSpriteFrame("color_plum_small");

            if (cardNum > 10) {
                bigColorValue = "color_plum_" + cardNum.toString();
            }else{
                bigColorValue = "color_plum_big";
            }
            this.bigColorSprite.spriteFrame = this.getSpriteFrame(bigColorValue)

        }else if(colour == "D"){

            //方块
            this.pointSprite.spriteFrame = this.getSpriteFrame("point_red_" + number);
            this.colorSprite.spriteFrame = this.getSpriteFrame("color_square_small");

            if (cardNum > 10) {
                bigColorValue = "color_square_" + cardNum.toString();
            }else{
                bigColorValue = "color_square_big";
            }
            this.bigColorSprite.spriteFrame = this.getSpriteFrame(bigColorValue)

        }            
        
        this.node.active = true;
    }

    hideCard(){

        this.node.active = false;
    }

    showBack(playerId : number, hidePoint : boolean = true){

        this.uid = playerId;        

        this.pointSprite.node.active = hidePoint ? false : true;
        this.colorSprite.node.active = hidePoint ? false : true;
        this.bigColorSprite.node.active = hidePoint ? false : true;
        this.backNode.active = true;
        this.backNode.opacity = 255;
        this.node.active = true;
 
        this.onUpdateBack();
       
    }

    private getSpriteFrame( frameName : string){
        
        return this.pokerAtlas.getSpriteFrame(frameName);
    }

}
